/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2IconButtonRecord1/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2IconButtonRecord1({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2IconButtonRecord1",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2IconButtonRecord1.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-1td66k': alignSelf,'--mt-2-1td66k': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1td66k': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1td66k': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1td66k': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1td66k': opacity,'--w-10-1td66k': typeof width === 'number' ? `${width}px` : width,'--h-11-1td66k': typeof height === 'number' ? `${height}px` : height,'--f-12-1td66k': fill,'--a-7-1td66k': isAnimated ? animation : "none",'--sd-8-1td66k': isAnimated ? strokeDashoffset : 0,'--sd-9-1td66k': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2IconButtonRecord1.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M14 7A7 7 0 110 7a7 7 0 0114 0zM9.5 7a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
 style={{'--f-12-1td66k': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}